export default "__VITE_ASSET__CLBAVvNH__"